var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_252_25033)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6809 0H6.33866C2.84532 0 0.00976562 2.83556 0.00976562 6.32889V17.6711C0.00976562 21.1644 2.84532 24 6.33866 24H17.6809C21.1653 24 24.0098 21.1644 24.0098 17.6711V6.32889C24.0098 2.83556 21.1653 0 17.6809 0ZM8.48977 18.1689H5.84087V9.6H8.48977V18.1689ZM7.15643 8.48C6.29421 8.48 5.5831 7.76889 5.5831 6.89778C5.5831 6.02667 6.28532 5.31556 7.15643 5.31556C8.02754 5.31556 8.72088 6.02667 8.72088 6.89778C8.72088 7.76889 8.01866 8.48 7.15643 8.48ZM18.4364 18.1689H15.7964V13.6711C15.7964 12.4356 15.3253 11.7511 14.3564 11.7511C13.2987 11.7511 12.7387 12.4711 12.7387 13.6711V18.1689H10.1964V9.6H12.7387V10.7556C12.7387 10.7556 13.5031 9.34222 15.3253 9.34222C17.1475 9.34222 18.4453 10.4533 18.4453 12.7467V18.1689H18.4364Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_252_25033"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.8e4f48bd87f47dbb874779c827260b51.svg";
export { ForwardRef as ReactComponent };